<template>
    <div class="w-full border bg-white mt-12 relative bottom-0">
        <div class="flex px-2 w-full md:w-10/12 lg:w-8/12 m-auto">
            <div class="text-center flex-1">
               All Rights Reserved © {{getYear()}}  | <a href="./PrivacyPolicy"  target="_blank">Privacy Policy</a>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'Navbar',
    components: {

    },
    async mounted(){

    },
    data () {
        return {

        }
    }, 
    methods: {
        getYear(){
           return new Date().getFullYear()
        }
    }
}
</script>
 
<style>

</style>
  


// WEBPACK FOOTER //
// src/components/Footer.vue